import { render } from "./SubNetworksSettingsPage.vue?vue&type=template&id=1f082286"
import script from "./SubNetworksSettingsPage.vue?vue&type=script&lang=js"
export * from "./SubNetworksSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__